import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../Context/HimmaContext';
import { UpdateItemStockRequestSchema } from '.././client-sdk/api';

const userData = JSON.parse(localStorage.getItem('userData') || '{}');
const localStorageStoreId = userData?.userDetails?.storeId 

export const useStockApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllStocks = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getAllItemStocks(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.merchantId,
          query.search
        );
        return response;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getEditStockQuantity = useCallback(
    async (itemId: any, stockData: UpdateItemStockRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.updateItemStock(itemId, stockData, localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllStocks,
    loading,
    error,
    getEditStockQuantity,
  };
};
